import { errorPagesConfigs } from "./errorPages";
import { authRouteConfig } from "./auth";
import { initialUrl } from "../shared/constants/AppConst";
import Error403 from "./errorPages/Error403";
import React from "react";
import { adminPagesConfigs } from "./admin";
import Error404 from "./errorPages/Error404";
import { profileConfig } from "./profile";
import Logout from "./auth/Logout";

const authorizedStructure = {
  fallbackPath: "/signin",
  unAuthorizedComponent: <Error403 />,
  routes: [
    // ...samplePagesConfigs,
    ...adminPagesConfigs,
    ...profileConfig,
  ],
};

const unAuthorizedStructure = {
  fallbackPath: initialUrl,
  routes: authRouteConfig,
};

const anonymousStructure = {
  routes: errorPagesConfigs.concat([
    {
      path: "*",
      element: <Error404 />,
    },
    {
      path: "/logout",
      element: <Logout />,
    },
  ]),
};

export { authorizedStructure, unAuthorizedStructure, anonymousStructure };
